var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareersillustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 511.26,
    height: 672.219,
    viewBox: "0 0 511.26 672.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M0-67.5H511.26V-739.72H0Z",
    transform: "translate(0 739.72)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M72.064-337.176H294.273V-570.225H72.064Z",
    transform: "translate(-72.064 570.225)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(0 739.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(0 -739.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0 31.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M-42.63-21.315c0,117.234-95.037,212.273-212.272,212.273S-467.175,95.919-467.175-21.315-372.137-233.588-254.9-233.588-42.63-138.55-42.63-21.315",
    transform: "translate(467.175 233.588)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(341.442 434.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M-3.809-1.9A18.968,18.968,0,0,1-22.778,17.064,18.969,18.969,0,0,1-41.747-1.9,18.969,18.969,0,0,1-22.778-20.874,18.969,18.969,0,0,1-3.809-1.9",
    transform: "translate(41.747 20.874)",
    fill: "#f2a51c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M301.528-164.108H27.832V-574.2h273.7Z",
    transform: "translate(-2.54 -15.104)",
    fill: "#f2a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M317.431-182H43.735V-592.092h273.7Z",
    transform: "translate(-3.991 -13.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M174.459-291.639H90.453v-7.226h84.006Z",
    transform: "translate(-8.254 -40.229)",
    fill: "#93a3bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M292.788-247.656H90.452v-7.225H292.788Z",
    transform: "translate(-8.254 -44.242)",
    fill: "#93a3bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M179.653-226.285h-89.2v-7.226h89.2Z",
    transform: "translate(-8.254 -46.192)",
    fill: "#93a3bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M121.165-275.736H90.453v-7.226h30.712Z",
    transform: "translate(-8.254 -41.68)",
    fill: "#93a3bf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 -739.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(65.488 154.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M-21.894-23.4H-235.756a4.173,4.173,0,0,1-4.173-4.173v-224.7a4.173,4.173,0,0,1,4.173-4.174H-21.894a4.173,4.173,0,0,1,4.173,4.174v224.7A4.173,4.173,0,0,1-21.894-23.4",
    transform: "translate(239.929 256.449)",
    fill: "#9b2dff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(65.488 -585.692)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(5.863 148.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M-20.9-10.665c-1.608-14.414-7.062-60.245-12.416-69.758-6.373-11.323-66.237-36.455-66.237-36.455l-25.661,16.29-25.751-16.147S-210.686-91.269-217-79.91c-5.3,9.544-10.5,55.4-12.025,69.826Z",
    transform: "translate(229.022 116.879)",
    fill: "#283056"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(125.257 -436.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M0-5.088,20.126,16.667l-7.77,11.726h29l-4.86-76.408L24.152-55.753Z",
    transform: "translate(0 55.753)",
    fill: "#4f5e82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(186.023 -436.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M-.445-.784-4.882,75.7H24.262l-7.98-11.9,20-21.866L11.853-8.59Z",
    transform: "translate(4.882 8.59)",
    fill: "#4f5e82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(65.488 -585.692)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(81.478 148.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M-2.831-1.636-28.582-17.782s-.891.38-2.444,1.058l12.97,105.346,30.109-.084L24.474-17.227c-1.049-.448-1.644-.7-1.644-.7Z",
    transform: "translate(31.026 17.926)",
    fill: "#f9f9fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(166.668 -410.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M-.609-.045-6.678,13.493l9.609,4.771L10.765,11.7,4.624-.5Z",
    transform: "translate(6.678 0.496)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(168.294 -399.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M-.45-.4-4.932,42.812H12.4L6.736-4.342Z",
    transform: "translate(4.932 4.342)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(0 -739.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(77.683 487.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M-1.675-.077l2.926,9a1.112,1.112,0,0,0,1.059.77h9.466a1.114,1.114,0,0,1,.655,2.015L4.772,17.275a1.113,1.113,0,0,0-.405,1.245l2.926,9a1.113,1.113,0,0,1-1.714,1.244L-2.08,23.2a1.116,1.116,0,0,0-1.309,0l-7.659,5.564a1.113,1.113,0,0,1-1.714-1.244l2.925-9a1.114,1.114,0,0,0-.4-1.245L-17.9,11.711A1.114,1.114,0,0,1-17.245,9.7h9.467a1.113,1.113,0,0,0,1.059-.77l2.925-9a1.114,1.114,0,0,1,2.118,0",
    transform: "translate(18.36 0.847)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(121.131 487.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M-1.675-.077l2.925,9a1.114,1.114,0,0,0,1.06.77h9.466a1.114,1.114,0,0,1,.654,2.015L4.771,17.275a1.114,1.114,0,0,0-.4,1.245l2.926,9a1.113,1.113,0,0,1-1.714,1.244L-2.08,23.2a1.117,1.117,0,0,0-1.31,0l-7.659,5.564a1.113,1.113,0,0,1-1.713-1.244l2.925-9a1.114,1.114,0,0,0-.4-1.245l-7.66-5.564A1.114,1.114,0,0,1-17.245,9.7h9.467a1.114,1.114,0,0,0,1.059-.77l2.925-9a1.114,1.114,0,0,1,2.118,0",
    transform: "translate(18.361 0.847)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(164.58 487.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M-1.675-.077l2.925,9a1.114,1.114,0,0,0,1.06.77h9.466a1.114,1.114,0,0,1,.655,2.015l-7.66,5.564a1.114,1.114,0,0,0-.4,1.245l2.926,9a1.113,1.113,0,0,1-1.714,1.244L-2.08,23.2a1.116,1.116,0,0,0-1.309,0l-7.659,5.564a1.113,1.113,0,0,1-1.714-1.244l2.925-9a1.114,1.114,0,0,0-.4-1.245L-17.9,11.711A1.114,1.114,0,0,1-17.245,9.7h9.467a1.114,1.114,0,0,0,1.059-.77l2.925-9a1.114,1.114,0,0,1,2.118,0",
    transform: "translate(18.36 0.847)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(208.028 487.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M-1.675-.077l2.925,9a1.114,1.114,0,0,0,1.06.77h9.466a1.114,1.114,0,0,1,.654,2.015L4.771,17.275a1.114,1.114,0,0,0-.4,1.245l2.926,9a1.113,1.113,0,0,1-1.714,1.244L-2.08,23.2a1.117,1.117,0,0,0-1.31,0l-7.659,5.564a1.113,1.113,0,0,1-1.713-1.244l2.925-9a1.114,1.114,0,0,0-.4-1.245l-7.66-5.564A1.114,1.114,0,0,1-17.245,9.7h9.467a1.114,1.114,0,0,0,1.059-.77l2.925-9a1.114,1.114,0,0,1,2.118,0",
    transform: "translate(18.361 0.847)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(251.476 487.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M-1.675-.077l2.926,9a1.113,1.113,0,0,0,1.059.77h9.467a1.113,1.113,0,0,1,.654,2.014L4.772,17.274a1.118,1.118,0,0,0-.405,1.246l2.925,9a1.113,1.113,0,0,1-1.713,1.244L-2.08,23.2a1.116,1.116,0,0,0-1.309,0l-7.659,5.564a1.113,1.113,0,0,1-1.714-1.244l2.926-9a1.118,1.118,0,0,0-.405-1.246L-17.9,11.71A1.113,1.113,0,0,1-17.245,9.7h9.467a1.113,1.113,0,0,0,1.059-.77l2.926-9a1.113,1.113,0,0,1,2.117,0",
    transform: "translate(18.36 0.847)",
    fill: "#fcba11"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M521.369-359.993H338.453V-473.807H521.369Z",
    transform: "translate(-30.884 -24.265)",
    fill: "#f2a51c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(375.089 -485.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M0-.1H99.98V45.453H101V-1.125H0Z",
    transform: "translate(0 1.125)",
    fill: "#283056"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(291.643 -485.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M-.205-3.187v-29.69h28.56v-2.044h-30.6V-3.187Z",
    transform: "translate(2.249 34.92)",
    fill: "#283056"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(292.154 -436.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M-4.11-6.57h-39.91V-72h-1.021V-5.548H-4.11Z",
    transform: "translate(45.042 71.997)",
    fill: "#283056"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(379.832 -403.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M-9.512,0V32.173h-94.726v2.044h96.77V0Z",
    transform: "translate(104.238)",
    fill: "#283056"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(0 -739.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(370.348 268.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M-2.449-1.225A12.194,12.194,0,0,1-14.643,10.969,12.193,12.193,0,0,1-26.837-1.225,12.194,12.194,0,0,1-14.643-13.419,12.2,12.2,0,0,1-2.449-1.225",
    transform: "translate(26.837 13.419)",
    fill: "#9b2dff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M483.3-402.693H356.842v-4.516H483.3Z",
    transform: "translate(-32.562 -30.342)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M452.018-386.79H395.11v-4.517h56.908Z",
    transform: "translate(-36.054 -31.793)",
    fill: "#93a3bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M460.4-370.887H384.86V-375.4H460.4Z",
    transform: "translate(-35.119 -33.245)",
    fill: "#93a3bf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(336.057 -216.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M-1.67-3.085,12.017-15.559-4.615-33.808-18.3-21.334Z",
    transform: "translate(18.302 33.808)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0 -739.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(313.44 427.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M-.419,0C-1.8.793-3.192,1.567-4.6,2.329V111.941A58.73,58.73,0,0,0,18.7,98.873a58.953,58.953,0,0,0,18.043-55.52A18.991,18.991,0,0,1,24.784,18.124q-1.067-1.313-2.218-2.576A58.745,58.745,0,0,0-.419,0",
    transform: "translate(4.596)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(313.44 426.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M0,0V3.708c1.4-.762,2.792-1.537,4.177-2.329Q2.11.61,0,0",
    fill: "#8e89bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(341.443 445.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M-.138,0A18.99,18.99,0,0,0,11.824,25.229,58.656,58.656,0,0,0-.138,0",
    transform: "translate(1.515)",
    fill: "#f9d693"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(238.024 424.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M-2.02-9.359a1.117,1.117,0,0,1-1.062-1.462l2.926-9a1.118,1.118,0,0,0-.405-1.246L-8.22-26.634a1.114,1.114,0,0,1,.654-2.015H1.9a1.113,1.113,0,0,0,1.059-.77l2.926-9a1.092,1.092,0,0,1,1.059-.77A1.092,1.092,0,0,1,8-38.423l2.926,9a1.113,1.113,0,0,0,1.059.77h9.467a1.114,1.114,0,0,1,.654,2.015l-7.659,5.563a1.118,1.118,0,0,0-.405,1.246l2.925,9A1.116,1.116,0,0,1,15.91-9.359a1.1,1.1,0,0,1-.652-.218L7.6-15.141a1.109,1.109,0,0,0-.654-.212,1.109,1.109,0,0,0-.654.212L-1.368-9.577a1.1,1.1,0,0,1-.652.218m38.852-93.2A58.766,58.766,0,0,0-2.881-87.174q-.613.559-1.205,1.13H24.378v7.225H-10.463A59,59,0,0,0-6.745-3.849,58.831,58.831,0,0,0,36.867,15.4a59.116,59.116,0,0,0,16.417-2.322V-100.236a59.246,59.246,0,0,0-16.451-2.327",
    transform: "translate(22.134 102.563)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(249.694 440.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M-3.5,0H-31.963a59.2,59.2,0,0,0-6.376,7.225H-3.5Z",
    transform: "translate(38.339)",
    fill: "#ccd3e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(251.476 487.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M-1.569,0A1.092,1.092,0,0,0-2.628.77l-2.926,9a1.113,1.113,0,0,1-1.059.77H-16.08a1.113,1.113,0,0,0-.654,2.014l7.659,5.564a1.118,1.118,0,0,1,.405,1.246l-2.926,9a1.117,1.117,0,0,0,1.062,1.462,1.1,1.1,0,0,0,.652-.218l7.659-5.564a1.11,1.11,0,0,1,.654-.213,1.11,1.11,0,0,1,.654.213l7.659,5.564a1.1,1.1,0,0,0,.652.218,1.116,1.116,0,0,0,1.061-1.462l-2.925-9a1.118,1.118,0,0,1,.405-1.246L13.6,12.557a1.113,1.113,0,0,0-.654-2.014H3.474a1.113,1.113,0,0,1-1.059-.77L-.51.77A1.092,1.092,0,0,0-1.569,0",
    transform: "translate(17.195)",
    fill: "#ffdd8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(361.33 423.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M-.039-.078A.39.39,0,0,0,.235-.192.391.391,0,0,0,.349-.466.394.394,0,0,0,.235-.74.394.394,0,0,0-.039-.854.391.391,0,0,0-.313-.74a.39.39,0,0,0-.114.274.387.387,0,0,0,.114.274.389.389,0,0,0,.274.114",
    transform: "translate(0.427 0.854)",
    fill: "#4260c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(239.401 395.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M-.013-2.146h0a.388.388,0,0,0-.04.547.387.387,0,0,0,.547.04h0a.387.387,0,0,0,.04-.547A.387.387,0,0,0-.013-2.146Zm1.788-1.5h0a.388.388,0,0,0-.055.545.389.389,0,0,0,.546.055h0A.388.388,0,0,0,2.321-3.6.387.387,0,0,0,1.775-3.651ZM3.6-5.109h0a.389.389,0,0,0-.069.545.389.389,0,0,0,.544.068h0a.389.389,0,0,0,.069-.544A.389.389,0,0,0,3.6-5.109ZM5.465-6.517h0a.388.388,0,0,0-.083.543.388.388,0,0,0,.543.083h0a.388.388,0,0,0,.083-.543.388.388,0,0,0-.543-.083m1.9-1.359h0a.388.388,0,0,0-.1.54.389.389,0,0,0,.541.1h0a.39.39,0,0,0,.1-.541.389.389,0,0,0-.541-.1M9.3-9.183h0a.387.387,0,0,0-.112.537.387.387,0,0,0,.537.111h0a.388.388,0,0,0,.112-.537A.388.388,0,0,0,9.3-9.184Zm1.971-1.257h0a.388.388,0,0,0-.126.534.388.388,0,0,0,.534.126h0a.388.388,0,0,0,.126-.534.387.387,0,0,0-.534-.125Zm2-1.2h0a.388.388,0,0,0-.141.53.389.389,0,0,0,.531.141h0a.388.388,0,0,0,.14-.531A.387.387,0,0,0,13.28-11.642Zm2.036-1.15h0a.388.388,0,0,0-.154.526.389.389,0,0,0,.527.154.388.388,0,0,0,.154-.526.389.389,0,0,0-.527-.154m2.066-1.094h0a.388.388,0,0,0-.168.522.389.389,0,0,0,.523.169h0a.389.389,0,0,0,.168-.523.387.387,0,0,0-.522-.168Zm2.1-1.039h0a.388.388,0,0,0-.183.517.388.388,0,0,0,.518.183h0a.389.389,0,0,0,.182-.518A.388.388,0,0,0,19.477-14.924Zm2.122-.982h0a.387.387,0,0,0-.2.513.388.388,0,0,0,.513.2h0a.389.389,0,0,0,.2-.513A.388.388,0,0,0,21.6-15.907Zm2.148-.925h0a.387.387,0,0,0-.209.507.388.388,0,0,0,.507.21h0a.388.388,0,0,0,.209-.507.388.388,0,0,0-.507-.21M25.92-17.7h0a.388.388,0,0,0-.224.5.389.389,0,0,0,.5.224h0a.388.388,0,0,0,.224-.5.389.389,0,0,0-.5-.224Zm2.2-.809h0a.387.387,0,0,0-.237.494.388.388,0,0,0,.5.237h0a.388.388,0,0,0,.236-.5.388.388,0,0,0-.5-.236Zm2.216-.75h0a.388.388,0,0,0-.25.488.389.389,0,0,0,.489.25.388.388,0,0,0,.25-.488.388.388,0,0,0-.489-.25m2.236-.691h0a.388.388,0,0,0-.263.482.388.388,0,0,0,.482.263h0a.388.388,0,0,0,.263-.482A.388.388,0,0,0,32.567-19.948Zm2.254-.631h0a.388.388,0,0,0-.275.475.388.388,0,0,0,.474.275h0A.387.387,0,0,0,35.3-20.3.389.389,0,0,0,34.821-20.579Zm2.269-.57h0a.388.388,0,0,0-.288.467.389.389,0,0,0,.467.288h0a.389.389,0,0,0,.288-.467A.387.387,0,0,0,37.09-21.148Zm2.285-.51h0a.388.388,0,0,0-.3.459.388.388,0,0,0,.459.3.388.388,0,0,0,.3-.459A.388.388,0,0,0,39.374-21.658Zm2.3-.448h0a.388.388,0,0,0-.313.451.388.388,0,0,0,.451.313h0a.388.388,0,0,0,.313-.451A.387.387,0,0,0,41.671-22.106Zm2.308-.387h0a.387.387,0,0,0-.324.442.388.388,0,0,0,.443.325h0a.389.389,0,0,0,.324-.443A.387.387,0,0,0,43.979-22.493ZM46.3-22.82h0a.387.387,0,0,0-.335.433.387.387,0,0,0,.433.336.388.388,0,0,0,.336-.433.389.389,0,0,0-.434-.336m2.326-.264h0a.389.389,0,0,0-.348.425.389.389,0,0,0,.424.347h0a.389.389,0,0,0,.347-.424.389.389,0,0,0-.425-.348Zm2.332-.2h0a.387.387,0,0,0-.359.415.388.388,0,0,0,.415.358.388.388,0,0,0,.359-.415.388.388,0,0,0-.415-.358m2.336-.141h0a.388.388,0,0,0-.37.406.388.388,0,0,0,.406.369.388.388,0,0,0,.369-.405A.388.388,0,0,0,53.291-23.427Zm2.339-.079h0a.389.389,0,0,0-.38.4.389.389,0,0,0,.4.38h0a.389.389,0,0,0,.38-.4A.388.388,0,0,0,55.63-23.506Zm2.341-.016h0a.387.387,0,0,0-.39.385.388.388,0,0,0,.385.391h0a.389.389,0,0,0,.391-.386A.388.388,0,0,0,57.971-23.522Zm2.341.045h0a.387.387,0,0,0-.4.375.387.387,0,0,0,.374.4.388.388,0,0,0,.4-.374.387.387,0,0,0-.375-.4m2.339.107h0A.388.388,0,0,0,62.24-23a.388.388,0,0,0,.364.41h0a.388.388,0,0,0,.411-.364.388.388,0,0,0-.364-.41m2.335.169h0a.387.387,0,0,0-.42.353.389.389,0,0,0,.354.42.388.388,0,0,0,.419-.354.387.387,0,0,0-.354-.419m2.331.23h0a.39.39,0,0,0-.43.343.389.389,0,0,0,.343.429h0a.388.388,0,0,0,.429-.343.389.389,0,0,0-.343-.429Zm2.323.293h0a.389.389,0,0,0-.438.331.389.389,0,0,0,.331.438.389.389,0,0,0,.438-.331.389.389,0,0,0-.331-.438m2.315.354h0a.388.388,0,0,0-.446.319.388.388,0,0,0,.319.446.388.388,0,0,0,.446-.319.387.387,0,0,0-.319-.446m2.3.414h0a.388.388,0,0,0-.454.307.388.388,0,0,0,.307.455h0a.388.388,0,0,0,.454-.308A.388.388,0,0,0,74.259-21.909Zm2.294.476h0a.387.387,0,0,0-.463.3.388.388,0,0,0,.294.463h0a.388.388,0,0,0,.463-.3A.388.388,0,0,0,76.552-21.433Zm2.28.537h0a.388.388,0,0,0-.471.283.389.389,0,0,0,.283.471h0a.389.389,0,0,0,.47-.284.388.388,0,0,0-.283-.47Zm2.265.6h0a.389.389,0,0,0-.478.27.389.389,0,0,0,.27.478h0a.389.389,0,0,0,.478-.27A.389.389,0,0,0,81.1-20.3Zm2.248.658h0a.387.387,0,0,0-.484.256.387.387,0,0,0,.257.485.387.387,0,0,0,.484-.257.388.388,0,0,0-.257-.484m2.23.717h0a.389.389,0,0,0-.492.244.389.389,0,0,0,.244.492h0a.389.389,0,0,0,.492-.244A.388.388,0,0,0,85.575-18.924Zm2.21.776h0a.388.388,0,0,0-.5.231.387.387,0,0,0,.231.5h0a.388.388,0,0,0,.5-.231A.389.389,0,0,0,87.785-18.148Zm2.189.836h0a.387.387,0,0,0-.5.217.388.388,0,0,0,.217.5h0a.387.387,0,0,0,.5-.217A.387.387,0,0,0,89.974-17.312Zm2.166.893h0a.388.388,0,0,0-.51.2.388.388,0,0,0,.2.51h0a.388.388,0,0,0,.509-.2A.388.388,0,0,0,92.141-16.418Zm2.142.951h0a.388.388,0,0,0-.515.19.389.389,0,0,0,.19.515h0a.389.389,0,0,0,.515-.191.388.388,0,0,0-.191-.514ZM96.4-14.458h0a.387.387,0,0,0-.52.176.387.387,0,0,0,.176.52.388.388,0,0,0,.519-.176.387.387,0,0,0-.175-.52m2.087,1.065h0a.388.388,0,0,0-.524.162.388.388,0,0,0,.163.524h0a.389.389,0,0,0,.524-.162A.389.389,0,0,0,98.486-13.393Zm2.059,1.121h0a.388.388,0,0,0-.529.148.387.387,0,0,0,.148.528.388.388,0,0,0,.528-.148.387.387,0,0,0-.147-.528m2.027,1.176h0a.388.388,0,0,0-.532.134.389.389,0,0,0,.134.533h0a.388.388,0,0,0,.532-.134A.386.386,0,0,0,102.572-11.1Zm2,1.23h0a.389.389,0,0,0-.536.12.388.388,0,0,0,.12.535h0a.388.388,0,0,0,.535-.12.388.388,0,0,0-.12-.535Zm1.962,1.284h0a.388.388,0,0,0-.539.1.389.389,0,0,0,.105.539.388.388,0,0,0,.539-.105.388.388,0,0,0-.105-.538m1.927,1.335h0a.387.387,0,0,0-.541.091.388.388,0,0,0,.09.542h0a.388.388,0,0,0,.542-.091A.388.388,0,0,0,108.458-7.247Zm1.891,1.388h0a.388.388,0,0,0-.543.076.388.388,0,0,0,.076.543h0a.388.388,0,0,0,.543-.076.388.388,0,0,0-.075-.543ZM112.2-4.422h0a.387.387,0,0,0-.545.062.388.388,0,0,0,.062.545.386.386,0,0,0,.544-.062.388.388,0,0,0-.061-.545m1.815,1.487h0a.389.389,0,0,0-.547.047.388.388,0,0,0,.047.546h0a.387.387,0,0,0,.546-.046A.389.389,0,0,0,114.018-2.935ZM115.793-1.4h0a.387.387,0,0,0-.548.033.388.388,0,0,0,.032.548h0a.388.388,0,0,0,.547-.033A.388.388,0,0,0,115.793-1.4ZM117.526.182h0a.388.388,0,1,0,.018.548.387.387,0,0,0-.018-.548M119.213,1.8h0a.388.388,0,1,0-.545.552h0a.388.388,0,1,0,.545-.552Zm1.643,1.667h0a.388.388,0,1,0-.559.538h0a.388.388,0,0,0,.561-.537Z",
    transform: "translate(0.148 23.522)",
    fill: "#4260c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(237.642 417.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M-.039-.078A.39.39,0,0,0,.235-.192.391.391,0,0,0,.349-.466.394.394,0,0,0,.235-.74.394.394,0,0,0-.039-.854.391.391,0,0,0-.313-.74a.39.39,0,0,0-.114.274.387.387,0,0,0,.114.274.389.389,0,0,0,.274.114",
    transform: "translate(0.427 0.854)",
    fill: "#4260c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(224.305 410.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M-1.9-12.218A72.7,72.7,0,0,0,100.8-7.456a72.7,72.7,0,0,0,4.762-102.7,72.7,72.7,0,0,0-102.7-4.763A72.7,72.7,0,0,0-1.9-12.218m10.138-9.24A58.983,58.983,0,0,1,12.1-104.783a58.982,58.982,0,0,1,83.326,3.863,58.983,58.983,0,0,1-3.864,83.326A58.983,58.983,0,0,1,8.233-21.458",
    transform: "translate(20.873 133.89)",
    fill: "#140577"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(339.128 -209.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M-9.986-13.566,18.528-39.554-80.915-148.667l-28.514,25.987Z",
    transform: "translate(109.429 148.667)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(438.571 -100.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M0-2.61,6.237,4.233,34.751-21.753,28.515-28.6Z",
    transform: "translate(0 28.597)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 -739.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(328.797 76.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M-4.354-7.165a28,28,0,0,1,28-28,28,28,0,0,1,28,28c0,.305-.035.6-.045.9h43.38c0-.3.024-.6.024-.9a71.359,71.359,0,0,0-71.36-71.359A71.358,71.358,0,0,0-47.711-7.165c0,.3.019.6.022.9H-4.308c-.009-.3-.045-.6-.045-.9",
    transform: "translate(47.711 78.524)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(395.639 171.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M-5.154-2.98l-32.7-29.681a27.772,27.772,0,0,1-14.111,3.852,28.111,28.111,0,0,1-4.516-.394v43.6c1.495.094,3,.157,4.516.157A71.033,71.033,0,0,0-5.154-2.98",
    transform: "translate(56.481 32.661)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(328.819 148.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M-4.356,0H-47.737a71.342,71.342,0,0,0,66.82,70.3V26.7A27.974,27.974,0,0,1-4.356,0",
    transform: "translate(47.737)",
    fill: "#9b2dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(318.476 66.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M-.077-8.2a80.658,80.658,0,0,1,23.7-57.214,80.658,80.658,0,0,1,57.214-23.7.384.384,0,0,0,.383-.383.384.384,0,0,0-.383-.383A81.681,81.681,0,0,0-.844-8.2a.384.384,0,0,0,.383.383A.384.384,0,0,0-.077-8.2Z",
    transform: "translate(0.844 89.881)",
    fill: "#283056"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M443.319-288.251H551.714v-8.129H443.319Z",
    transform: "translate(-40.454 -40.456)",
    fill: "#c6d8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M518.179-243.521h-74.86v-8.129h74.86Z",
    transform: "translate(-40.454 -44.537)",
    fill: "#c6d8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M481.934-265.885H443.319v-8.13h38.615Z",
    transform: "translate(-40.454 -42.496)",
    fill: "#c6d8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M502.921-265.885H491.4v-8.13h11.517Z",
    transform: "translate(-44.841 -42.496)",
    fill: "#c6d8f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(0 -739.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(398.869 155.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M-.011-.066,66.832,65.875a.383.383,0,0,0,.538-.546L.527-.611a.383.383,0,0,0-.543,0,.383.383,0,0,0,0,.542",
    transform: "translate(0.125 0.722)",
    fill: "#283056"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(212.646 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M-10.265-9.368a23.255,23.255,0,0,1-15.652-7.067,50.448,50.448,0,0,0,14.66-35.609,50.616,50.616,0,0,0-50.616-50.616A50.617,50.617,0,0,0-112.49-52.045,50.616,50.616,0,0,0-61.874-1.429,50.383,50.383,0,0,0-37.834-7.5,39.412,39.412,0,0,0-10.265-9.368",
    transform: "translate(112.49 102.661)",
    fill: "#9b2dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(203.701 4.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M-10.316-9.419l.032-.51A22.734,22.734,0,0,1-25.6-16.844l-.366.357.364.359A50.954,50.954,0,0,0-10.8-52.1a51.128,51.128,0,0,0-51.127-51.127A51.128,51.128,0,0,0-113.052-52.1,51.129,51.129,0,0,0-61.925-.968,50.9,50.9,0,0,0-37.641-7.1l-.243-.449-.144.49A40.477,40.477,0,0,0-26.6-5.412,38.249,38.249,0,0,0-10.077-8.968l1.6-.849-1.811-.113-.032.51-.239-.452-.068.035A37.637,37.637,0,0,1-26.6-6.434a39.45,39.45,0,0,1-11.139-1.6l-.2-.059-.184.1a49.872,49.872,0,0,1-23.8,6.006A49.946,49.946,0,0,1-97.354-16.666,49.946,49.946,0,0,1-112.03-52.1,49.944,49.944,0,0,1-97.354-87.525,49.946,49.946,0,0,1-61.925-102.2a49.948,49.948,0,0,1,35.43,14.675A49.947,49.947,0,0,1-11.82-52.1,49.933,49.933,0,0,1-26.331-16.846l-.354.356.35.36A23.767,23.767,0,0,0-10.348-8.909l.032-.51-.239-.452Z",
    transform: "translate(113.052 103.223)",
    fill: "#283056"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(235.234 -711.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M-2.117-4.557-23.2-25.642l8.42-8.421L-2.117-21.4,26.424-49.941l8.42,8.42Z",
    transform: "translate(23.197 49.941)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(0 -739.72)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(150.156 176.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M-6.247-.824Q3.239,7.385,3.239,22.741q0,14.306-9.259,22.435t-24.769,8.432v13.4H-55.033V37.044h10.089q10.842,0,16.865-3.086t6.022-11.067q0-5.117-2.861-7.981A10.389,10.389,0,0,0-32.6,12.049q-5.421,0-8.508,3.238a11.412,11.412,0,0,0-3.086,8.206H-68.433A31.146,31.146,0,0,1-64.594,7.006,28.867,28.867,0,0,1-52.021-4.739q8.432-4.292,20.328-4.291,15.959,0,25.447,8.206M-29.435,105.1h-26.8V79.355h26.8Zm0-25.748",
    transform: "translate(68.454 9.03)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersillustration);
export default __webpack_public_path__ + "static/media/careersillustration.fb06dee369249dd9a25ca3d51e3bf142.svg";
export { ForwardRef as ReactComponent };